export enum UserPermissionRank {
   staff = 1,
   management = 2,
   admin = 3,
}

export const UserPermissionRankNames = {
   1: "Mitarbeiter:in",
   2: "Verwaltung",
   3: "Admin",
}